/* eslint-disable max-len */
import * as R from 'ramda';
import moment from 'moment';
import angular from 'angular';

export default function EditControlDialogController(
  $q,
  $rootScope,
  $scope,
  $timeout,
  copy,
  ssDialogService,
  alerts,
  loaderService,
  controlDataService
) {
  const vm = this;

  vm.handleCloseDialogClick = _handleCloseDialogClick;
  vm.handleSelectMediaTypeClick = _handleSelectMediaTypeClick;
  vm.handleEditControlSubmit = _handleEditControlSubmit;
  vm.handleControlTypeChange = _handleControlTypeChange;

  _activate();

  // //////// METHODS //////////

  function _activate() {
    vm.newControl = angular.copy(vm.control);
    saveDefaultValue();
    vm.firstLoad = true;
    if (vm.control.customerRiskControl) {
      vm.selectedRisk = {};
      vm.selectedRisk.Id = vm.control.customerRiskControl.customerRiskId;
    } else if (vm.risk) {
      vm.selectedRisk = {};
      vm.selectedRisk.Id = vm.risk.customerRiskId;
    }
  }

  function _handleCloseDialogClick() {
    ssDialogService.hide(ssDialogService.dialogs.controlAdmin.editControlDialog);
  }

  function _handleSelectMediaTypeClick(mediaTypeId) {
    console.log(`vm._handleSelectMediaTypeClick mediaTypeId:${mediaTypeId}`);
    vm.newMediaInputs.mediaTypeId = mediaTypeId;
    $scope.editControlForm.$setPristine();
  }

  function _handleEditControlSubmit($event) {
    if ($scope.editControlForm.$valid) {
      loaderService.showViewLoader = true;
      if (!R.isNil(vm.control.lastReviewDate)) {
        vm.control.lastReviewDate = moment(vm.control.lastReviewDate);
      }
      vm.control.createdDate = new Date();
      if (vm.selectedRisk) {
        const _selectedRisk = {};
        _selectedRisk.customerRiskControlId = vm.control.customerRiskControlID || 0;
        _selectedRisk.customerControlId = vm.control.customerControlId;
        _selectedRisk.customerRiskId = vm.selectedRisk.Id;
        // _selectedRisk.customerRisk = vm.selectedRisk;
        vm.control.customerRiskControl = _selectedRisk;
      }
      if (vm.control.controlReviewType) {
        vm.control.controlReviewScheduleId = vm.control.controlReviewSchedule.controlReviewScheduleId;
      }
      if (vm.control.controlReviewType) {
        vm.control.controlReviewTypeId = vm.control.controlReviewType.controlReviewTypeId;
      }
      if (vm.control.controlResult) {
        vm.control.controlResultId = vm.control.controlResult.controlResultId;
      }
      const isNew = vm.control.customerControlId === 0;
      controlDataService.saveControl(vm.control).then((response) => {
        if (!response.data) {
          alerts.error('Error occurred while saving the control.');
        } else {
          alerts.success('The control has been saved successfully.');
          vm.saved = true;
          loaderService.showViewLoader = false;
          switch (vm.saveType) {
            case 'saveAndAddAnother':
              _resetViewModel($event);
              $rootScope.$broadcast('refreshControlType', { customerControlTypeId: vm.control.customerControlTypeId });
              if (vm.risk) {
                vm.risk.control = response.data;
                if (isNew === true) {
                  vm.risk.action = 'add';
                } else {
                  vm.risk.action = 'update';
                }
                $rootScope.$broadcast('refreshRiskControls', { risk: vm.risk });
              }
              break;
            default:
              _closeDialog();
              $rootScope.$broadcast('refreshControlType', { customerControlTypeId: vm.control.customerControlTypeId });
              $rootScope.$broadcast('refreshCustomerControl', { customerControlId: vm.control.customerControlId });
              if (vm.risk) {
                vm.risk.control = response.data;
                if (isNew === true) {
                  vm.risk.action = 'add';
                } else {
                  vm.risk.action = 'update';
                }
                $rootScope.$broadcast('refreshRiskControls', { risk: vm.risk });
              }
              if (vm.updateCallBack) {
                vm.updateCallBack();
              }
          }
        }
      });
      // _saveControl();
    }
  }

  function _resetViewModel() {
    $timeout(
      () => {
        vm.control.newName = '';
        vm.control.name = '';
        vm.control.customerControlId = 0;
        vm.selectedRisk = vm.selectedRisk;
        vm.control.customerControlType = null;
        resetDefaultValue();
        $scope.editControlForm.$setPristine();
        $scope.editControlForm.$setUntouched();
        $timeout(
          () => {
            angular.element('#dialogContent_editControlDialog')[0].scrollTop = 0;
          }, 0
        );
      },
      100
    );
  }

  function resetDefaultValue() {
    vm.control.controlPreventiveEffectivenessId = angular.copy(vm.controlPreventiveEffectivenessOld);
    vm.control.controlDetectiveEffectivenessId = angular.copy(vm.controlDetectiveEffectivenessOld);
    vm.control.controlCorrectiveEffectivenessId = angular.copy(vm.controlCorrectiveEffectivenessOld);
    vm.control.controlAdministrativeNatureId = angular.copy(vm.controlAdministrativeNatureOld);
    vm.control.controlTechnicalNatureId = angular.copy(vm.controlTechnicalNatureOld);
    vm.control.controlPhysicalNatureId = angular.copy(vm.controlPhysicalNatureOld);
    vm.control.controlPrimaryControlTypeId = angular.copy(vm.controlPrimaryControlTypeOld);
    vm.control.controlCompensatingControlTypeId = angular.copy(vm.controlCompensatingControlTypeOld);
    // vm.controlType.controlReviewSchedule = angular.copy(vm.controlReviewScheduleOld);
  }

  function _closeDialog() {
    ssDialogService.hide(ssDialogService.dialogs.controlAdmin.editControlDialog);
  }

  function _handleControlTypeChange() {
    if (vm.control.customerControlId > 0 && vm.firstLoad === true) {
      vm.firstLoad = false;
      return;
    }
    if (vm.control.customerControlType) {
      vm.control.customerControlTypeId = vm.control.customerControlType.customerControlTypeId;
      vm.control.controlPreventiveEffectivenessId = vm.control.customerControlType.controlPreventiveEffectivenessId;
      vm.control.controlDetectiveEffectivenessId = vm.control.customerControlType.controlDetectiveEffectivenessId;
      vm.control.controlCorrectiveEffectivenessId = vm.control.customerControlType.controlCorrectiveEffectivenessId;
      vm.control.controlAdministrativeNatureId = vm.control.customerControlType.controlAdministrativeNatureId;
      vm.control.controlTechnicalNatureId = vm.control.customerControlType.controlTechnicalNatureId;
      vm.control.controlPhysicalNatureId = vm.control.customerControlType.controlPhysicalNatureId;
      vm.control.controlPrimaryControlTypeId = vm.control.customerControlType.controlPrimaryControlTypeId;
      vm.control.controlCompensatingControlTypeId = vm.control.customerControlType.controlCompensatingControlTypeId;
      // vm.control.controlReviewSchedule = vm.controlType.controlReviewSchedule;
      // vm.control.controlReviewType = vm.controlType.controlReviewType;
      // vm.control.controlResult = vm.controlType.controlResult;
    }
  }

  function saveDefaultValue() {
    vm.controlPreventiveEffectivenessOld = angular.copy(vm.control.controlPreventiveEffectivenessId);
    vm.controlDetectiveEffectivenessOld = angular.copy(vm.control.controlDetectiveEffectivenessId);
    vm.controlCorrectiveEffectivenessOld = angular.copy(vm.control.controlCorrectiveEffectivenessId);
    vm.controlAdministrativeNatureOld = angular.copy(vm.control.controlAdministrativeNatureId);
    vm.controlTechnicalNatureOld = angular.copy(vm.control.controlTechnicalNatureId);
    vm.controlPhysicalNatureOld = angular.copy(vm.control.controlPhysicalNatureId);
    vm.controlPrimaryControlTypeOld = angular.copy(vm.control.controlPrimaryControlTypeId);
    vm.controlCompensatingControlTypeOld = angular.copy(vm.control.controlCompensatingControlTypeId);
    // vm.controlReviewScheduleOld = angular.copy(vm.controlType.controlReviewSchedule);
  }
}

EditControlDialogController.$inject = [
  '$q',
  '$rootScope',
  '$scope',
  '$timeout',
  'copy',
  'ssDialogService',
  'alerts',
  'loaderService',
  'controlDataService',
];
